import en from './en-US';
import de from './de-DE';
import fr from './fr-CA';

export default {
  ...en,
  ...de,
  ...fr,
};
